// /legal/privacy — static privacy policy page
import React from 'react';

interface Props {
  onBack: () => void;
}

export function PrivacyPage({ onBack }: Props) {
  return (
    <div style={pageStyle}>
      <button onClick={onBack} style={backStyle}>← Back</button>
      <article style={articleStyle}>
        <h1 style={h1Style}>Privacy Policy</h1>
        <p style={mutedStyle}>Last updated: April 2026</p>

        <Section title="What we collect">
          <p>When you sign in with Google, we receive your name, email address, and profile picture. We store these to create your account. We also store the posts you create, including track selections, clip timestamps, and captions.</p>
        </Section>

        <Section title="How we use it">
          <p>Your data is used solely to operate mylodic — displaying your profile, showing your posts in the feed, and enabling social features like follows and resonances. We do not sell your data or use it for advertising.</p>
        </Section>

        <Section title="Audio and music">
          <p>mylodic does not store audio files from Spotify. Clip metadata (track ID, start time, duration) is stored to identify which moment you're sharing. Audio playback uses YouTube's IFrame API for exact clip playback, and Apple's iTunes Search API for preview fallback.</p>
        </Section>

        <Section title="Cookies">
          <p>We use a single session cookie (HttpOnly, Secure) to keep you logged in. No third-party tracking cookies are set. Cloudflare Web Analytics is used for aggregate traffic analysis — it does not set cookies or track individuals.</p>
        </Section>

        <Section title="Data retention">
          <p>Your data is retained as long as your account exists. You can delete your account at any time from Settings → Edit Profile → Danger Zone. Deletion removes all your posts, audio metadata, follows, and resonances immediately and permanently.</p>
        </Section>

        <Section title="Contact">
          <p>Questions? Email <a href="mailto:mylodic.contact@gmail.com" style={{ color: 'var(--accent)' }}>mylodic.contact@gmail.com</a>.</p>
        </Section>
      </article>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section style={{ marginTop: 28 }}>
      <h2 style={{ fontSize: 15, fontWeight: 700, marginBottom: 8 }}>{title}</h2>
      <div style={{ fontSize: 14, color: 'var(--text-muted)', lineHeight: 1.7 }}>{children}</div>
    </section>
  );
}

const pageStyle: React.CSSProperties = {
  maxWidth: 620,
  margin: '0 auto',
  padding: '24px 20px 64px',
};

const backStyle: React.CSSProperties = {
  fontSize: 13,
  color: 'var(--text-muted)',
  marginBottom: 28,
  display: 'inline-block',
  cursor: 'pointer',
};

const articleStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
};

const h1Style: React.CSSProperties = {
  fontSize: 24,
  fontWeight: 800,
  letterSpacing: '-0.02em',
  marginBottom: 4,
};

const mutedStyle: React.CSSProperties = {
  fontSize: 12,
  color: 'var(--text-muted)',
};
